import type { UsageBucket } from "../lib/api";

function fmt(ts: string, granularity: "day" | "hour"): string {
  return granularity === "day"
    ? ts.slice(0, 10)
    : `${ts.slice(0, 10)} ${ts.slice(11, 16)}`;
}

export function UsageTable({
  buckets,
  granularity,
}: {
  buckets: UsageBucket[];
  granularity: "day" | "hour";
}) {
  if (buckets.length === 0) {
    return (
      <p className="text-sm text-muted-foreground">
        Keine Daten im gewählten Zeitraum.
      </p>
    );
  }
  const sorted = [...buckets].sort((a, b) =>
    b.bucket.localeCompare(a.bucket),
  );
  return (
    <div className="overflow-hidden rounded-md border">
      <table className="w-full text-sm">
        <thead className="bg-muted text-left">
          <tr>
            <th className="px-3 py-2">Zeitpunkt</th>
            <th className="px-3 py-2 text-right">Runs</th>
            <th className="px-3 py-2 text-right">Tool calls</th>
            <th className="px-3 py-2 text-right">Prompt-Tokens</th>
            <th className="px-3 py-2 text-right">Completion-Tokens</th>
            <th className="px-3 py-2 text-right">Search Credits</th>
          </tr>
        </thead>
        <tbody>
          {sorted.map((b) => (
            <tr key={b.bucket} className="border-t">
              <td className="px-3 py-2 font-mono">
                {fmt(b.bucket, granularity)}
              </td>
              <td className="px-3 py-2 text-right">{b.run_count}</td>
              <td className="px-3 py-2 text-right">{b.tool_calls}</td>
              <td className="px-3 py-2 text-right">{b.prompt_tokens}</td>
              <td className="px-3 py-2 text-right">{b.completion_tokens}</td>
              <td className="px-3 py-2 text-right">{b.search_credits}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
